const FONT_ASSETS = [
  ['MYRIADPRO-REGULAR.OTF', 'myriadpro', 'normal'],
  ['MYRIADPRO-BOLD.OTF', 'myriadpro', 'bold'],
  ['Myriad Pro Italic.ttf', 'myriadpro', 'italic'],
];

let fontDataPromise;

const arrayBufferToBinary = (buffer) => {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  const chunkSize = 0x8000;
  for (let offset = 0; offset < bytes.length; offset += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(offset, offset + chunkSize));
  }
  return binary;
};

const loadFontData = () => {
  if (!fontDataPromise) {
    fontDataPromise = Promise.all(FONT_ASSETS.map(async ([filename, family, style]) => {
      const response = await fetch(`${process.env.PUBLIC_URL || ''}/certificate/fonts/${encodeURIComponent(filename)}`);
      if (!response.ok) throw new Error(`Unable to load certificate font: ${filename}`);
      return { binary: arrayBufferToBinary(await response.arrayBuffer()), family, style };
    }));
  }
  return fontDataPromise;
};

export const registerCertificateFonts = async (doc) => {
  try {
    const fonts = await loadFontData();
    fonts.forEach(({ binary, family, style }) => {
      doc.addFileToVFS(`${family}-${style}.otf`, binary);
      doc.addFont(`${family}-${style}.otf`, family, style);
    });
    return true;
  } catch (error) {
    // Keep PDF export usable if a deployment omits the optional font assets.
    return false;
  }
};
